export const BusinessColorTypes = {
  BLACK: 1,
  WHITE: 2,
}

export const BUSINESS_COLORS = [
  {
    id: BusinessColorTypes.BLACK,
    name: 'Обсидиан',
    swatch: '#121212',
    theme: 'dark',
  },
  {
    id: BusinessColorTypes.WHITE,
    name: 'Жемчуг',
    swatch: '#f4f4f5',
    theme: 'light',
  },
]

export function businessColorById(colorType) {
  const id = Number(colorType)
  return BUSINESS_COLORS.find((color) => color.id === id) || BUSINESS_COLORS[0]
}

export function themeFromColorType(colorType) {
  return businessColorById(colorType).theme
}
